// errors-handler.ts
import { ErrorHandler, Injectable} from '@angular/core';
import { MatSnackBar } from '@angular/material';
@Injectable()
export class ErrorsHandler implements ErrorHandler {
    constructor(
        private snackbar: MatSnackBar
    ){}
  handleError(error: Error) {
     // Do whatever you like with the error (send it to the server?)
     // And log it to the console
     console.error('Error catch : ', error);
     if(error.message.indexOf("detectChanges") == -1){
        /*this.snackbar.open("Error lors de l'action précédente",'', {
           duration: 2000,
           panelClass:'error-snackbar'
         });*/
     }
  }
}